import { render } from "./BillingDataFullAccess.vue?vue&type=template&id=7019b2ac&scoped=true"
const script = {}

import "./BillingDataFullAccess.vue?vue&type=style&index=0&id=7019b2ac&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7019b2ac"]])

export default __exports__